/**
 * Tuetut kielet.
 *
 * Kieli on käyttöliittymän asia, mutta se asuu jaetussa paketissa, koska
 * muotoilufunktiot (`format.ts`) ottavat sen parametrina — ilman yhteistä
 * tyyppiä jokainen kutsupaikka joutuisi keksimään oman merkkijononsa.
 *
 * `LOCALES` erottaa kielen ja lokaalin toisistaan: kieli on se, minkä
 * käyttäjä valitsee (`fi`), lokaali se, minkä `Intl` ymmärtää (`fi-FI`).
 * Englanti muotoillaan brittienglannin mukaan: se on eurooppalaiselle
 * lukijalle tutumpi päiväys- ja lukumuoto kuin amerikkalainen.
 */
export const APP_LANGUAGES = ['fi', 'en'];
/** Kieli, jolla sovellus on kirjoitettu ja johon aina palataan. */
export const DEFAULT_LANGUAGE = 'fi';
export const LOCALES = {
    fi: 'fi-FI',
    en: 'en-GB',
};
export function isAppLanguage(value) {
    return typeof value === 'string' && APP_LANGUAGES.includes(value);
}
//# sourceMappingURL=i18n.js.map